import React from 'react'

export default function Number<K>({
    label,
    onChange,
    props,
    name,
    disabled = false
}: {
    name: string
    label: string    
    onChange: (rule: K) => void
    props: K
    disabled?:boolean
}) {
    return (
        <div>
            <label>{label}</label>
            <input 
                disabled={disabled}
                type={'number'}
                onChange={({ target }) => onChange({ ...props, [name]: target?.value })}
                value={props[name]}
            />
        </div>
    )
}
